const MAX_LABEL_LENGTH = 30
const TRAILING_CONNECTORS = new Set(['a', 'as', 'com', 'da', 'das', 'de', 'do', 'dos', 'e', 'em', 'para', 'por', 'sem'])

export function formatSearchHighlightLabel(value: string): string {
  const normalized = value.trim().replace(/\s+/g, ' ').split('(')[0].trim()
  if (!normalized) return ''

  const words = normalized.split(' ')
  const selected: string[] = []

  for (const word of words) {
    if (/^\d/.test(word) && selected.length >= 2) break

    const candidate = [...selected, word].join(' ')
    if (candidate.length > MAX_LABEL_LENGTH && selected.length > 0) break
    selected.push(word)
  }

  while (selected.length > 1 && TRAILING_CONNECTORS.has(selected[selected.length - 1].toLocaleLowerCase('pt-BR'))) {
    selected.pop()
  }

  return selected.join(' ')
}
